import React, {useState, useEffect, useContext} from 'react';
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import axios from 'axios'; 
import './OrderTable.css';
import repeat_icon from '../Assets/repeat.png';
import { ShopContext } from '../../Context/ShopContext';

const OrderTable = () => {
    const adminEmail = process.env.REACT_APP_EMAIL_ADMIN;
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    const [loading, setLoading] = useState([false]);
    let navigate = useNavigate();
    const apiURL = process.env.REACT_APP_API_URL;
    const [dataProduct, setDataProduct] = useState([]);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [currOrderId, setCurrOrderId] = useState("");
    const [status, setStatus] = useState('idle');
    const { addToCart } = useContext(ShopContext);
        
    useEffect(() => {
        let getUrl = (loggedInUser.email === adminEmail) ? apiURL + `api/order/all/active` : apiURL + `api/order/email?email=${encodeURIComponent(loggedInUser.email)}`;
        axios.get(getUrl, {
            headers: {
                Accept: 'application/json',
                "ngrok-skip-browser-warning": "10423"
            }
        })
        .then((res) => {
            setDataProduct(res.data);
        })
        .catch((err) => console.log(err));
    }, []); 

    const handleAddToCart = (orderId) => {
        setStatus('ADDING'); // Start loading
        axios.get(apiURL + `api/order/repeat?orderId=${encodeURIComponent(orderId)}`, {
            headers: {
                Accept: 'application/json',
                "ngrok-skip-browser-warning": "10497"
            }
        }).then((res) => {
            res.data.products.map((ent)=> {
                addToCart(ent.id, ent.quantity); 
            }) 
            setStatus('idle');
            navigate('/cart', { replace: true });
        }).catch((err) => {
            console.log(err);
            setStatus('idle');
        });
        
        
        setTimeout(() => {
             // Reset after 2 sec
        }, 5000);
    }

    const handleDeliveryStatus = (event) => {
        setShowLoginPopup(false);
        setLoading(true);
        axios.put(apiURL + `api/order/update?orderId=${encodeURIComponent(currOrderId)}`, {
            headers: {
                Accept: 'application/json',
                "ngrok-skip-browser-warning": "10431"
            }
        }).then((res) => {
            setLoading(false);
            alert(`Order updated successfully with id:` + res.data);
            setCurrOrderId("");
            window.location.reload();
        }).catch((err) => {
            console.log(err);
            setLoading(false);
            setCurrOrderId("");
            alert(`Error occured, please try later`);
        });
    };
    return (
        <div className="table-container">
            <h3 className='notfound'>Your Order Details</h3>
            {loading === true ? <div className='spinner'><RotatingLines
            visible={true}
            height="96"
            width="96"
            color="grey"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
        /></div> : (<table>
        <thead>
        <tr>
            <th>Order Id</th>
            <th>Products</th>
            <th>Amount</th>
            <th>Delivery/Pickup</th>
            <th>Status</th>
            <th>Actions</th>
        </tr>
        </thead>
        {dataProduct.length > 0 ? dataProduct.map((e, i) => (
            <tbody>
            <tr key={i}>
            <td>
                <span className="cell-header">Order Id:</span> <p>{e.id}</p>
            </td>
            <td>
                <span className="cell-header">Products:</span> {e.products.map(item => {
                    return <span><p>{item.name} - {item.quantity}</p>
                    </span>
                })}
            </td>
            <td>
                <span className="cell-header">Amount:</span> <p>{e.amount}</p>
            </td>
            <td>
                <span className="cell-header">Delivery/Pickup:</span> <p>{e.delivery}</p>
            </td>
            <td>
                <span className="cell-header">Status:</span> <p>{e.delivered === true ? "completed" : "pending"}</p>
            </td>
            <td>
                <span className="cell-header">Actions:</span>
                    { loggedInUser.email === adminEmail ?  !e.delivered ? <p><button className="upd-delivery" onClick={() => {setShowLoginPopup(true); setCurrOrderId(e.id)}}>Update delivery/pickup</button></p> : <p>N/A</p>
                    : <p><button disabled={status === "ADDING"} className="repeat-icon" onClick={() => handleAddToCart(e.id)}>Reorder</button></p>} 
                </td>
            </tr></tbody>
        )) : <caption>No Orders Found</caption> }
        
        </table>)}
        {showLoginPopup && (
        <div className="login-popup">
          <div className="login-popup-content">
            <h3>Update delivery status</h3>
            <p>Please click OK if order has been delivered/picked successfully.</p>
            <button onClick={handleDeliveryStatus}>Ok</button>
            <button onClick={() => setShowLoginPopup(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
)
}

export default OrderTable;